import { render, staticRenderFns } from "./SortTableQuery.vue?vue&type=template&id=498540be&"
import script from "./SortTableQuery.vue?vue&type=script&lang=js&"
export * from "./SortTableQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports